import React from 'react';
import { ThemeProvider } from './components/theme-provider';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { Products } from './components/sections/Products';
import { HowItWorksModern } from './components/sections/HowItWorksModern';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { FloatingCTA } from './components/ui/FloatingCTA';
import { Waitlist } from './components/sections/Waitlist';
import { Privacy } from './components/sections/Privacy';
import { Terms } from './components/sections/Terms';
export function App() {
  const renderContent = () => {
    switch (window.location.pathname) {
      case '/waitlist':
        return <Waitlist data-id="element-0" />;
      case '/privacy':
        return <Privacy data-id="element-1" />;
      case '/terms':
        return <Terms data-id="element-2" />;
      default:
        return <>
            <Hero data-id="element-3" />
            <Products data-id="element-4" />
            <HowItWorksModern data-id="element-5" />
            <Pricing data-id="element-6" />
            <FAQ data-id="element-7" />
            <FinalCTA data-id="element-8" />
          </>;
    }
  };
  return <ThemeProvider defaultTheme="light" storageKey="realtyzen-theme" data-id="element-9">
      <div className="min-h-screen bg-background" data-id="element-10">
        <Header data-id="element-11" />
        <main className="motion-safe:animate-in fade-in slide-in-from-bottom-4 duration-200" data-id="element-12">
          {renderContent()}
        </main>
        <Footer data-id="element-13" />
        {window.location.pathname === '/' && <FloatingCTA data-id="element-14" />}
      </div>
    </ThemeProvider>;
}